// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/get-company-by-id-request-schema',
  type: 'object',
  required: ['id', 'eventIdentifier'],
  properties: {
    id: {
      type: 'integer',
    },
    eventIdentifier: {
      type: 'string',
      format: 'uuid',
    },
  },
} as IJSONSchema;

export default schema;
